<template>
    <div class="module4">
        <img src="../../../assets/image/m4_img1.png" alt="示例图" />
    </div>
</template>

<style lang="scss" scoped>
.module4{
    img{
        width: 100%;
    }
}
</style>